import { ChevronDown, X, type LucideIcon } from 'lucide-react'
import { Boton, clasesBoton, ColorBoton, Menu, OpcionMenu } from '../kit'

export interface AccionBarra {
  clave: string
  texto: string
  Icono: LucideIcon
  onClick: () => void
  color?: ColorBoton
  /** En el escritorio va en el menú «Más», no como botón. */
  secundaria?: boolean
}

const opcion = (a: AccionBarra, grupo: number): OpcionMenu => ({ clave: a.clave, texto: a.texto, Icono: a.Icono, grupo, peligro: a.color === 'error' })

/**
 * La línea sobre una lista de bienes: un texto (cuántos hay, una pista) y, al marcar
 * alguno, cuántos van marcados con las acciones de la lista y «Desmarcar». Mide siempre
 * lo mismo, para que al marcar el primero la tabla no se corra y el siguiente clic no
 * caiga en otra fila. En una pantalla ancha las acciones secundarias van en «Más»; en
 * una angosta (bajo 1200px, ver styles/app.css) no caben en una línea y van todas en el
 * menú «Acciones».
 */
export function BarraSeleccion({
  texto, marcados, acciones, onDesmarcar,
}: {
  texto: string
  marcados: number
  acciones: AccionBarra[]
  onDesmarcar: () => void
}) {
  const activa = marcados > 0
  const principales = acciones.filter((a) => !a.secundaria)
  const secundarias = acciones.filter((a) => a.secundaria)
  const elegir = (clave: string) => (clave === 'desmarcar' ? onDesmarcar() : acciones.find((a) => a.clave === clave)?.onClick())
  return (
    <div className={`barra-lista${activa ? ' barra-lista--activa' : ''}`} role="region" aria-label="Bienes de la lista">
      <span className="barra-lista__cuenta" aria-live="polite">
        {activa ? `${marcados.toLocaleString('es-CL')} ${marcados === 1 ? 'marcado' : 'marcados'}` : texto}
      </span>
      {activa && (
        <>
          <span className="barra-lista__acciones">
            {principales.map((a) => (
              <Boton key={a.clave} tam="sm" icono={a.Icono} color={a.color} onClick={a.onClick}>{a.texto}</Boton>
            ))}
            {secundarias.length > 0 && (
              <Menu
                etiqueta="Más acciones para los marcados"
                claseDisparador={clasesBoton('text', 'primary', 'sm')}
                disparador={<>Más <ChevronDown className="dcc-i" size={16} aria-hidden /></>}
                alineado="fin"
                opciones={secundarias.map((a) => opcion(a, 0))}
                onElegir={elegir}
              />
            )}
            <Boton tam="sm" variante="text" onClick={onDesmarcar}>Desmarcar</Boton>
          </span>
          <span className="barra-lista__menu">
            <Menu
              etiqueta="Acciones para los marcados"
              claseDisparador={clasesBoton('contained', 'primary', 'sm')}
              disparador={<>Acciones <ChevronDown className="dcc-i" size={16} aria-hidden /></>}
              alineado="fin"
              opciones={[
                ...principales.map((a) => opcion(a, 0)),
                ...secundarias.map((a) => opcion(a, 1)),
                { clave: 'desmarcar', texto: 'Desmarcar', Icono: X, grupo: 2 },
              ]}
              onElegir={elegir}
            />
          </span>
        </>
      )}
    </div>
  )
}
